import React, { useState } from 'react'
import { Spacer } from '../Spacer/Spacer'
import { SpacerSpacing } from '../Spacer/SpacerSpacing.type'
import { AnalyticsTagBuilder } from '@dai-team/analytics-library'
import { NotificationType } from './NotificationType.type'
import './style.module.scss'
import xss from 'xss'

export type NotificationProps = {
  children?: React.ReactNode
  className?: string
  message?: string
  analytics?: string
  psnAnalytics?: string
  type: NotificationType
  dismissable: boolean
  componentSpacing?: SpacerSpacing
  handleCloseNotification?: (closed: boolean) => void
  testId?: string
}

export const Notification = (props: NotificationProps) => {
  const {
    className,
    children,
    message,
    analytics,
    psnAnalytics,
    type,
    dismissable,
    componentSpacing,
    handleCloseNotification,
    testId
  } = props
  const notificationClass =
    'Notification ' +
    (dismissable ? 'Notification--dismissable ' : '') +
    'Notification--withIcon Notification--' +
    type
  const ariaRole = type == 'alert' ? 'alert' : 'status'
  const atb = new AnalyticsTagBuilder()
    .setDefaultName('Notification')
    .setAnalyticsName(analytics)
    .setPsnAnalytics(psnAnalytics)
  const [hideNotification, setHideNotification] = useState(false)

  const closeNotification = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault()
    setHideNotification(true)
    if (handleCloseNotification) {
      handleCloseNotification(true)
    }
  }

  if (hideNotification) {
    return null
  }

  return (
    <Spacer spacing={componentSpacing}>
      <section
        className={`u-sizeConstrained u-marginTop4gu ${className ?? ''}`}
        data-testid={testId ? `${testId}` : null}
      >
        <div
          className={notificationClass}
          role={ariaRole}
          data-testid={testId ? `${testId}-type` : null}
        >
          <div className="Notification-content">
            <div
              className={dismissable ? 'u-marginRight2gu' : ''}
              data-testid={testId ? `${testId}-message` : null}
            >
              <div
                className="Notification-message Content u-inline"
                data-testid={testId ? `${testId}-content` : null}
              >
                {message && (
                  <span dangerouslySetInnerHTML={{ __html: xss(message) }} />
                )}
                {children}
              </div>
            </div>
            {dismissable && (
              <button
                className="Notification-close Button Button--icon"
                onClick={closeNotification}
                {...atb.dataAnalyticAttribute('close')}
                data-testid={testId ? `${testId}-close` : null}
              >
                <span className="u-hiddenVisually">Dismiss notification</span>
                close
              </button>
            )}
          </div>
        </div>
      </section>
    </Spacer>
  )
}
